export default __webpack_public_path__ + "static/media/desc-bg-xs.6a5bfbfe.svg";